var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 11.2H4.225A3.975 3.975 0 0 0 .25 15.173v26.9a3.975 3.975 0 0 0 3.975 3.975H9.5a3.975 3.975 0 0 0 3.975-3.975v-26.9A3.975 3.975 0 0 0 9.5 11.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.325 18.45 10-15.225a5.6 5.6 0 0 1 10.2 4.075l-1.3 7.5a3 3 0 0 0 2.925 3.524h10.175a4.426 4.426 0 0 1 4.2 5.75l-6.475 21.2a5.67 5.67 0 0 1-5.4 3.975H25a8.5 8.5 0 0 1-5-1.55l-6.5-5.2z",
    opacity: 0.3
  })));
};
export default SvgLike;